import { Injectable, signal } from '@angular/core';
import { RulesFields, RulesForm, RulesFormGroups, RulesValidators } from '../models/fidelity-rule.model';
import { CustomFormControl, CustomFormGroup } from '@tilby/tilby-ui-lib/components/tilby-magic-form';
import { Validators } from '@angular/forms';

@Injectable()
export class FidelityRuleFormService {

  private ruleForm!: RulesFormGroups;
  
  get form() {
    return this.ruleForm;
  }

  ruleFormReady = signal(false);

  validators: RulesValidators = {
    nameMaxLength: 255,

    // --------
    provMinLength: 0,
    provMaxLength: 255,
    provMaxLengthArray: new Array(10).fill(2)
  };

  createForm(rule: RulesFields | null, hiddenFields?:Array<keyof RulesFields>) {
    this.ruleFormReady.set(false);
    this.ruleForm = new CustomFormGroup<RulesForm>({
      id: new CustomFormControl(
        rule?.id || null
      ),
      name: new CustomFormControl(
        rule?.name || null,
        { validators: [Validators.required, Validators.maxLength(this.validators.nameMaxLength)] }
      ),
      points: new CustomFormControl(
        rule?.points || null,
        { validators: [Validators.required] }
      ),
      type: new CustomFormControl(
        rule?.type || null,
        { validators: [Validators.required] }
      ),
      min_threshold: new CustomFormControl(
        rule?.min_threshold || null
      ),
      max_threshold: new CustomFormControl(
        rule?.max_threshold || null
      ),
      exclude_to_min: new CustomFormControl(
        rule?.exclude_to_min != null? rule.exclude_to_min : false
      ),
      param1: new CustomFormControl(
        rule?.param1 || null
      )
    });

    this.ruleFormReady.set(true);
    return this.ruleForm;
  }

  get id() {
    return this.ruleForm.controls.id;
  }

  get name() {
    return this.ruleForm.controls.name;
  }

  get points() {
    return this.ruleForm.controls.points;
  }

  get type() {
    return this.ruleForm.controls.type;
  }

  get min_threshold() {
    return this.ruleForm.controls.min_threshold;
  }

  get max_threshold() {
    return this.ruleForm.controls.max_threshold;
  }

  get exclude_to_min() {
    return this.ruleForm.controls.exclude_to_min;
  }

  get param1() {
    return this.ruleForm.controls.param1;
  }
}
